<div class="modal-container-custom">
  <div class="modal-content-custom mcfStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">Master Creation Form</h4>
    </div>
    <div class="modal-body">
      <form  autocomplete="off" [formGroup]="mcfAdditionalDataForm">
        <div class="row">
          <div class="col-md-9">
            Do you want to send Section A of the Master Creation Form?
          </div>
          <div class="col-md-3">
            <select class="form-control select-box select-block-box" formControlName="answer">
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer modal-footer-custom">
      <button type="button" class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left" (click)="activeModal.close()">Cancel</button>
      <button type="submit" class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left" (click)="saveSectionA()">Generate</button>
    </div>
  </div>
</div>